import { Box, IconButton, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { RiDeleteBinLine, RiFileEditLine } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux';
import CTable from '../../../components/Table/table'
import { deleteSubjectAssistPhoneRequest } from '../../../modules/admin-modules/subject-assist-phones/Actions';
import { openCreateSubjectAssistPhone } from '../../../modules/admin-modules/models/Actions';
import { getAllSubjectsRequest } from '../../../modules/admin-modules/subjects/Actions';

const SubjectAssistPhonesTable = ({ setAdd, setSelectedData }) => {
    const subjectAssistPhones = useSelector((state) => state.subjectAssistPhones.subjectAssistPhones)
    const dispatch = useDispatch()
    const isLoading = useSelector((state) => state.subjectAssistPhones.isLoading)
    const subjects = useSelector((state) => state.subjects.subjects)
    const [offset, setPage] = useState(0);
    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);
    const [selected, setSelected] = useState({
        id: ''
    })
    
    useEffect(() => {
        dispatch(getAllSubjectsRequest());
    }, [dispatch]);
    
    const viewData = (data) => {
        setSelectedData(data);
        setSelected(data);
        setAdd(false);
        dispatch(openCreateSubjectAssistPhone());
    };
    
    const getSubjectName = (subjectId) => {
        const subject = subjects?.find(s => s.id === subjectId);
        return subject?.name || subject?.nameAr || 'غير محدد';
    };
    
    const Data =
        subjectAssistPhones?.map((data) => {
            return {
                ...data,
                id: data?.id,
                phone: data?.phone,
                type: data?.type === 1 ? 'سكرتارية' : 'علمي',
                edit: (
                    <IconButton
                        variant='outline'
                        border='0'
                        color='gray.600'
                        aria-label='Edit Phone'
                        fontSize='20px'
                        icon={<RiFileEditLine />}
                        onClick={(e) => {
                            e.stopPropagation();
                            setSelectedData(data);
                            setAdd(false);
                            dispatch(openCreateSubjectAssistPhone());
                        }}
                    />
                ),
                delete: (<IconButton
                    variant='outline'
                    border='0'
                    color='gray.600'
                    aria-label='Delete Phone'
                    fontSize='20px'
                    icon={<RiDeleteBinLine color='red' />}
                    onClick={(e) => {
                        e.stopPropagation();
                        dispatch(deleteSubjectAssistPhoneRequest(data?.id));
                    }}
                />)
            };
        })
    const columns = [
        {
            Header: 'رقم الهاتف',
            accessor: 'phone'
        },
        {
            Header: 'النوع',
            accessor: 'type'
        },
        {
            Header: 'تعديل',
            accessor: 'edit'
        },
        {
            Header: 'حذف',
            accessor: 'delete'
        }
    ];


    return (
        <CTable
            selectedData={viewData}
            Columns={columns}
            Data={Data}
            path={'openModel'}
            Actions
            Title={``}
            subTitle=''
            btnTitle=""
            placeHolder=""
            noSearchBar={true}
            noFilter={true}
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar={true}
            isLoading={isLoading}
            perPage={size}
            totalPage={Math.ceil(subjectAssistPhones?.length / 10)}

        />
    )
}

export default SubjectAssistPhonesTable

